import React, { Component } from 'react'
import { Tab, Tabs } from 'material-ui/Tabs'
import Paper from 'material-ui/Paper'
import { FormattedMessage } from 'react-intl'
import UpcomingSeminars from './UpcomingSeminars'
import { checkAdminUrl, getToken, isSentry } from '../../lib'
import config from '../../config/config'

const APIurl = `${config.URI}/api/v1/get_contract`
const APIRoomurl = `${config.URI}/api/v1/rooms`

class SeminarTabs extends Component {
  constructor (props) {
    super(props)

    this.state = {
      rooms: [],
      index_0: '#4688F1',
      index_1: '#afb8c5',
      room_name: '',
      payed: false,
      fvroom_name: '',
      max_room_num_per_user: '',
      domain_id: ''
    }
  }

  randomName = () => {
    var text = ''
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    for (var i = 0; i < 20; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    return text
  }

  componentDidMount () {
    return fetch(`${APIurl}`, {
      method: 'GET',
      headers: {
        'Authenticity-Token': getToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status && res.status === 'success') {

          this.getRoom()

          if (res.data.expire_flag && res.data.account === 'admin') {
            alert('アカウントの有効期限が切れています。管理者に相談してください。')
          } else if (res.data.status === 'invalid') {
            alert('アカウントが無効です。管理者に相談してください。')
          } else if (res.data.expire_flag === null && res.data.account === 'free_admin') {
            // このユーザはいつか無効にしないといけない
            // var date = new Date
            // var mydate =new Date('2018-09-01');
            // if( date > mydate ){
            //   alert("アカウントの有効期限が切れています。管理者に相談してください。")
            // }
          }
        }
      })
      .catch((err) => {
        isSentry(err)
        console.log(err)
      })
  }

  componentWillMount () {
    const token = getToken()
    if (checkAdminUrl(this.props.pathname)) {
      this.props.fetchUpcomingSeminarRooms(token, false, true)
    } else {
      this.props.fetchUpcomingSeminarRooms(token, 'guest', true)
    }

  }

  handleTabChange = e => {
    const index = e.props.index
    const token = getToken()
    if (index === 0) {
      if (checkAdminUrl(this.props.pathname)) {
        this.props.fetchUpcomingSeminarRooms(token)
      } else {
        this.props.fetchUpcomingSeminarRooms(token, 'guest')
      }
      this.setState({index_0: '#4688F1', index_1: '#afb8c5'})
    } else if (index === 1) {
      if (checkAdminUrl(this.props.pathname)) {
        this.props.fetchPreviousSeminarRooms(token)
      } else {
        this.props.fetchPreviousSeminarRooms(token, 'guest')
      }
      this.setState({index_1: '#4688F1', index_0: '#afb8c5'})
    }
  }

  keyPress = (e) => {
    if (e.keyCode == 13) {
      if (this.state.payed) {
        this.createRoom()
      } else {
        this.joinRoom()
      }
    }
  }

  createRoom = () => {
    if (this.state.rooms.length > 4) {
      alert('Premiumプランでは5部屋以上作成できません。\nwebinar@anets.co.jpへお問い合わせください。')
      return
    }

    if (!this.state.room_name || this.state.room_name.length == 0) {
      alert('部屋の名前を入力してください')
      return
    }
    const payload = {
      name: this.state.room_name,
      fvroom_name: this.state.fv_domains_name,
      room_type: `dd`
    }
    return fetch(`${config.URI}/api/v1/rooms`, {
      method: 'POST',
      headers: {
        'Authenticity-Token': getToken(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status && res.status === 'success') {
          this.setState({room_name: ''})
          this.getRoom()
        } else {
          if (res.errors.room[0] == 'Name has already been taken') {
            alert('同じ部屋名が存在します')
          } else if (res.errors.room == 'Room already exists') {
            alert('同じ部屋名が存在します')
          } else {
            alert('例外的なエラーが発生しました。')
          }
        }
      })
      .catch((err) => {
        alert('サーバーとの接続にエラーが発生しました。')
        isSentry(err)
      })
  }
  joinRoom = () => {
    if (!this.state.room_name || this.state.room_name.length == 0) {
      alert('部屋の名前を入力してください')
      return
    }
    if (window.location.hostname == 'admin.dd-talk.net') {
      window.open('https://dd-talk.net/' + this.state.room_name)
    } else {
      window.open('https://video-dev.dd-talk.net/' + this.state.room_name)
    }
  }

  getRoom = () => {
    return fetch(`${APIRoomurl}`, {
      method: 'GET',
      headers: {
        'Authenticity-Token': getToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.data.hasOwnProperty('rooms')) {
          this.setState({rooms: res.data.rooms, payed: res.data.sessions_plan == 'premium' ? true : false})
        }
      })
      .catch((e) => {
        console.log(e)
        isSentry(e)
        alert('サーバーとの接続にエラーが発生しました。')
      })
  }

  render () {
    const {isFetchingPreviousRooms, isFetchingRooms} = this.props
    return (
      <Paper style={{borderRight: '2px solid #e3e3e3', height: '85vh', padding: null}}>
        <Tabs
          inkBarStyle={{background: '#4688F1', height: 3}}
          tabItemContainerStyle={{
            backgroundColor: '#FFFFFF',
            color: '#4688F1',
            borderBottom: '1px solid #d9d9d9',
            paddingTop: '10px'
          }}
        >
          <Tab
            onActive={this.handleTabChange}
            buttonStyle={{color: this.state.index_0}}
            label={<FormattedMessage id="seminar.upcoming"/>}
          >
            {isFetchingRooms ? (
                <div>Loading...</div>
              ) :
              <UpcomingSeminars
                guest={!checkAdminUrl(this.props.pathname)}
                selectConferenceId={this.props.selectConferenceId}
                selectConference={this.props.selectConference}
                fetchConferenceDetails={this.props.fetchConferenceDetails}
                rooms={this.props.upCommingRooms}
              />}
          </Tab>
          <Tab
            onActive={this.handleTabChange}
            buttonStyle={{color: this.state.index_1}}
            label={<FormattedMessage id="seminar.previous"/>}
          >
            {isFetchingPreviousRooms ? (
              <div>Loading...</div>
            ) : (
              <UpcomingSeminars
                guest={!checkAdminUrl(this.props.pathname)}
                selectConferenceId={this.props.selectConferenceId}
                selectConference={this.props.selectConference}
                fetchConferenceDetails={this.props.fetchConferenceDetails}
                rooms={this.props.previousRooms}
              />
            )}
          </Tab>
        </Tabs>
      </Paper>
    )
  }
}

export default SeminarTabs



// WEBPACK FOOTER //
// ./src/components/Seminars/Seminars.js